import React from "react";
import "../index.css";

function Coursemap({ year_semester, coursemapUnits, setCoursemapUnits }) {
  return (
    <div class="overflow-x-auto relative m-3">
      <h2 class="text-xl font-extrabold dark:text-white mb-2">Your Coursemap Planner</h2>
      <table class="border border-gray-300 w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" class="py-3 px-2">
              Year/Semester
            </th>
            <th scope="col" class="py-3 px-2">
              Unit 1
            </th>
            <th scope="col" class="py-3 px-2">
              Unit 2
            </th>
            <th scope="col" class="py-3 px-2">
              Unit 3
            </th>
            <th scope="col" class="py-3 px-2">
              Unit 4
            </th>
          </tr>
        </thead>
        <tbody>
          {year_semester &&
            year_semester.map((ys, row) => (
              <tr class="bg-white border-b dark:bg-white-800 dark:border-gray-700">
                <th
                  scope="row"
                  class="py-4 px-2 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {ys}
                </th>
                {[0, 1, 2, 3].map((col) => (
                  <td class="py-4 px-2">
                    <input
                      value={coursemapUnits[row * 4 + col]}
                      className="bg-white border border-gray-200 w-20 px-2 py-1"
                      onDoubleClick={async () => {
                        const text = await navigator.clipboard.readText();
                        if (text.length === 7) {
                          setCoursemapUnits((prevCoursemapUnits) =>
                          prevCoursemapUnits.map((unit, idx) =>
                            idx === row * 4 + col ? text : unit,
                          ));
                        }
                        
                      }}

                      maxLength={7}
                      onChange={(e) =>
                        setCoursemapUnits((prevCoursemapUnits) =>
                          prevCoursemapUnits.map((unit, idx) =>
                            idx === row * 4 + col ? e.target.value.toUpperCase() : unit,
                          ),
                        )
                      }
                    />
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default Coursemap;
